import { useState } from 'react';
import './Applicantsregdet.css';
import api from '.././jobsite/Components/api.js';  
let Applicantsregdet=(props)=>{
    let [Inputs, setInputs]= useState({});
    let inputchangehandel=(e)=>{
        let name= e.target.name;
        let value = e.target.value;
        setInputs(values =>({...values, [name]: value}));


    }
    let [inpdocreq, setinpdocreq]= useState(null);
    let [docreqall, setdocreqall]= useState(null);
    

    let inputtypefilechanhandel=(event)=>{  
        let name=event.target.name;
        let value =(URL.createObjectURL(event.target.files[0])); 
        let valuee =event.target.files[0]; 

        setinpdocreq(values =>({...values, [name]: value}));
        setdocreqall(values =>({...values, [name]: valuee}));

    } 
 
    
    let finalformsubmitbtn= async(e)=>{ 
        e.preventDefault();   
        if(Inputs.aplcntname == null){ 
            props.Successandrerrorfun("", "Applicant name required"); 
            return;

        }else if(Inputs.fathername == null){

            props.Successandrerrorfun("", "Father name required");

            return;
        }else if(Inputs.mothername == null){
            props.Successandrerrorfun("", "Mother name required");
            return;
        }else if(Inputs.dob == null){
            props.Successandrerrorfun("", "Date of birth required");
            return;
        }else if(Inputs.hnum == null){

           props.Successandrerrorfun("", "House no required");
            return;
        }else if(Inputs.vill == null){

           props.Successandrerrorfun("", "village required");
            return;
        }else if(Inputs.postoffice == null){

           props.Successandrerrorfun("", "PostOffice required");
            return;
        }else if(Inputs.thana == null){

           props.Successandrerrorfun("", "Thana required");
            return;
        }else if(Inputs.district == null){

           props.Successandrerrorfun("", "District required");
            return;
        }else if(Inputs.state == null){

           props.Successandrerrorfun("", "State required");
            return;
        }else if(Inputs.pincode == null){

           props.Successandrerrorfun("", "Pincode required");
            return;
        }else if(Inputs.mobnum == null){

           props.Successandrerrorfun("", "Mobile number required");
            return;
        }else if(Inputs.emailid == null){

            props.Successandrerrorfun("", "Email-id required");
            return;
        }else if(Inputs.weight == null){

            props.Successandrerrorfun("", "Weight required");
            return;
        }else if(Inputs.height == null){

            props.Successandrerrorfun("", "Height required");
            return;
        }else if(Inputs.chest == null){

            props.Successandrerrorfun("", "Chest required");
            return;
        }else if(Inputs.pwpd == null){

            props.Successandrerrorfun("", "PwPD required");
            return;
        }else if(Inputs.mark1 == null){

            props.Successandrerrorfun("", "Body mark 1st required");
            return;
        }else if(Inputs.mark2 == null){

            props.Successandrerrorfun("", "Body mark 2nd required");
            return;
        }else if(Inputs.password == null){

            props.Successandrerrorfun("", "Password must required");
            return;
        }else 
        if(docreqall?.photo == null){

            props.Successandrerrorfun("", "Photo must required");
            return;
        }else if(docreqall?.sign == null){

            props.Successandrerrorfun("", "Signature must required");
            return;
        }else if(docreqall?.aadharcard == null){

            props.Successandrerrorfun("", "Password must required");
            return;
        }else if(docreqall?.tenth == null){

            props.Successandrerrorfun("", "Please upload 10th marksheet");
            return;
        }else if(docreqall?.twelthcth == null){

            props.Successandrerrorfun("", "Please upload 12th marksheet");
            return;
        }
        
        let applicantformdata = new FormData();
        applicantformdata.append('applicantname', Inputs.aplcntname);
        applicantformdata.append('fathername', Inputs.fathername);
        applicantformdata.append('mothername', Inputs.mothername);
        applicantformdata.append('dob', Inputs.dob);
        applicantformdata.append('mobilenum', Inputs.mobnum);
        applicantformdata.append('emailid', Inputs.emailid);
        applicantformdata.append('altnum', Inputs.altrnum); 
        applicantformdata.append('hnum', Inputs.hnum);
        applicantformdata.append('village', Inputs.vill);
        applicantformdata.append('postoffice', Inputs.postoffice);
        applicantformdata.append('thana', Inputs.thana);
        applicantformdata.append('district', Inputs.district);
        applicantformdata.append('state', Inputs.state);
        applicantformdata.append('pincode', Inputs.pincode);
        applicantformdata.append('weight', Inputs.weight);
        applicantformdata.append('height', Inputs.height);
        applicantformdata.append('chest', Inputs.chest);
        applicantformdata.append('PwPD', Inputs.pwpd);
        applicantformdata.append('markone', Inputs.mark1);
        applicantformdata.append('marktwo', Inputs.mark2);
        applicantformdata.append('password', Inputs.password);
        applicantformdata.append('photo', docreqall?.photo);
        applicantformdata.append('sign',    docreqall?.sign);
        applicantformdata.append('aadharcard', docreqall?.aadharcard);
        applicantformdata.append('pancard', docreqall?.pancard);
        applicantformdata.append('tenth',   docreqall?.tenth);
        applicantformdata.append('twelthcth',   docreqall?.twelthcth);
        applicantformdata.append('underpostgraduation',   docreqall?.underpostgraduation);
        applicantformdata.append('cast',  docreqall?.cast);

 

       try {
         const resp= await api.post('applicantsdetails.php', applicantformdata);
         document.querySelector(".sucfulregistration").style.display="block";
         document.querySelector(".appregmaincont").style.display="none";
        document.querySelector(".sucregmsg").innerHTML = resp.data.result;
         

 
       } catch (error) {
            console.log(error);
       }
        
    }
    return(
       <div>
         <div className='popupdiv'>
                <p style={{backgroundColor:"green", color:"white"}} className='success samemsg'></p>
                <p style={{backgroundColor:"red", color:"white"}} className='error samemsg'></p>
        </div>
        <div style={{display:"none"}} className='sucfulregistration'>
            <div className='selfregsubcont'>
                <p className='sucregmsg'></p>
                <div className='linkcont'>
                    <a href="/applicants-register-form">back</a>
                    <a href='/'>Home</a>
                </div>
            </div>
            
        </div>
         <form onSubmit={finalformsubmitbtn} className='appregmaincont'>
            <h2 className='appregheading'>Register Applicants Details</h2>
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Personal Details</p>
                <div className='inpcontperdet'>
                    <input onChange={inputchangehandel} name='aplcntname' type='text' placeholder='Applicant Name'/>
                    <input onChange={inputchangehandel} name='fathername' type='text' placeholder='Father Name'/>
                    <input onChange={inputchangehandel} name='mothername' type='text' placeholder='Mother Name'/>
                    <input onChange={inputchangehandel} name='dob' type='text' placeholder='Date of Birth'/>
                </div>
            </div>  
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Address</p>
                <div className='inpcontperdet'>
                    <input onChange={inputchangehandel} name='hnum' type='text' placeholder='House no'/>
                    <input  onChange={inputchangehandel} name='vill' type='text' placeholder='Village'/>
                    <input  onChange={inputchangehandel} name='thana' type='text' placeholder='Thana'/>
                    <input onChange={inputchangehandel} name='postoffice' type='text' placeholder='Post Office'/>
                    <input onChange={inputchangehandel} name='district' type='text' placeholder='District'/>
                    <input onChange={inputchangehandel} name='state' type='text' placeholder='State'/>
                    <input onChange={inputchangehandel} name='pincode' type='text' placeholder='Pin Code'/>
                </div>
            </div>
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Contact Details</p>
                <div className='inpcontperdet'>
                    <input onChange={inputchangehandel} name='mobnum' type='text' placeholder='Mobile number'/>
                    <input onChange={inputchangehandel} name='emailid' type='text' placeholder='Email-id'/>
                    <input onChange={inputchangehandel} name='altrnum' type='text' placeholder='Alternate number'/> 
                </div>
            </div>
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Physical Details</p>
                <div className='inpcontperdet'>
                    <input onChange={inputchangehandel} name='height' type='text' placeholder='Height'/>
                    <input onChange={inputchangehandel} name='weight' type='text' placeholder='Weight'/>
                    <input  onChange={inputchangehandel} name='chest' type='text' placeholder='Chest'/>  
                    <input onChange={inputchangehandel} name='pwpd' title='Person with physical disability' type='text' placeholder='PwPD'/> 
                </div>
            </div>
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Physical Identification mark(cut, burn, mole, Birth mark on body)</p>
                <div className='inpcontperdet'>
                    <input  onChange={inputchangehandel} name='mark1' type='text' placeholder='Makr 1st'/>
                    <input  onChange={inputchangehandel} name='mark2' type='text' placeholder='Mark 2nd'/> 
                </div>
            </div>
             <div className='perdetcontaplicntreg'> 
                <div className='inpcontperdet'>
                   <p>*Please do not forgot</p>
                    <input onChange={inputchangehandel} name='password' type='text' placeholder='Enter password'/>
                </div> 
            </div>
            <div className='perdetcontaplicntreg'>
                <p className='perdetaplicntreg'>Documents Upload <span style={{color:"red"}}>(* Marked Required Fildes)</span></p>
                <div className='inpcontperdet uploadinpcont'>
                    <div className='uplodingdiv'>
                        <label htmlFor='photo'>Upload Photo<span style={{color:"red"}}>*</span></label>
                        <input id='photo' style={{display:"none"}} name='photo' onChange={inputtypefilechanhandel} type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.photo}/>
                        </div>
                    </div> 
                    <div className='uplodingdiv'>
                        <label htmlFor='sig'>Upload Signature<span style={{color:"red"}}>*</span></label>
                        <input style={{display:"none"}} id='sig' name='sign' onChange={inputtypefilechanhandel} type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"60px"}} src={inpdocreq?.sign}/>
                        </div>
                    </div> 
                    <div className='uplodingdiv'>
                        <label htmlFor='aadharcard'>Aadhar card<span style={{color:"red"}}>*</span></label>
                        <input style={{display:"none"}} id='aadharcard' name='aadharcard' onChange={inputtypefilechanhandel} type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.aadharcard}/>
                        </div>
                    </div> 
                     <div className='uplodingdiv'>
                        <label htmlFor='pancard'>Pan card</label>
                        <input style={{display:"none"}} id='pancard' name='pancard' onChange={inputtypefilechanhandel} type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.pancard}/>
                        </div>
                    </div> 
                    <div className='uplodingdiv'>
                        <label htmlFor='tenth'>Upload Matriculation(10th)<span style={{color:"red"}}>*</span></label>
                        <input style={{display:"none"}} id='tenth' name='tenth' onChange={inputtypefilechanhandel} type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.tenth}/>
                        </div>
                    </div> 
                     <div className='uplodingdiv'>
                        <label htmlFor='intermed'>Upload Intermediate(12th)<span style={{color:"red"}}>*</span></label>
                        <input style={{display:"none"}} id='intermed'  onChange={inputtypefilechanhandel} name='twelthcth' type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.twelthcth}/>
                        </div>
                    </div> 
                     <div className='uplodingdiv'>
                        <label htmlFor='graduation' style={{width:"130px"}}>Under/Post Graduation/iti</label>
                        <input style={{display:"none"}} id='graduation'  onChange={inputtypefilechanhandel} name='underpostgraduation' type='file'/>
                        <div>
                            <img alt=''   style={{width:"150px", height:"150px"}} src={inpdocreq?.underpostgraduation}/>
                        </div>
                    </div> 
                    <div className='uplodingdiv'>
                        <label htmlFor='cast'> Upload Cast</label>
                        <input style={{display:"none"}} id='cast'  onChange={inputtypefilechanhandel} name='cast' type='file'/>
                        <div>
                            <img alt=''  style={{width:"150px", height:"150px"}} src={inpdocreq?.cast}/>
                        </div>
                    </div> 
                </div>
            </div>









            <div className='perdetcontaplicntreg'>
                <input className='submitbbtn' type='submit' value="submit"/>
                <a className='submitbbtn' href='/forms-filler-comp'>back</a>
            </div> 
            
           
        </form>
       </div>
    );
}
export default Applicantsregdet;